import { sendFile } from "../../firebase/functions"
import { v4 as uuidv4 } from "uuid"

export const useUploadFile = (file, setErrorFile, type, nameFile = "") => {
  const uploadFile =
    file &&
    sendFile(file, uuidv4() || nameFile, type)
      .then((response) => response)
      .catch((e) => () => setErrorFile && setErrorFile(true))

  return uploadFile
}

export const sendFileToFirebase = async (base64, file) => {

  const getMimeTypeFromBase64 = (base64String) => {
    if (typeof base64String !== 'string') return null

    const match = base64String.match(/^data:(.*?);base64,/)
    return match ? match[1] : null;
  }

  const type = getMimeTypeFromBase64(base64)
  const firebaseData = await sendFile(base64, uuidv4(), type)
  return firebaseData
}

export const processFile = async (file, returnContentType = false) => {

  const isValidBase64 = (str) => {
    if (typeof str !== 'string') return false;
    const base64Regex = /^(data:\w+\/[a-zA-Z0-9.+-]+;base64,)?[A-Za-z0-9+/]+={0,2}$/;
    return base64Regex.test(str);
  }

  try {
    if (returnContentType) {
      const base64 = isValidBase64(file) ? file : await blobToBase64(file)

      let mime = base64.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/)
      let result = ""

      if (mime && mime.length) {
        result = mime[1]
      }

      const url = await sendFileToFirebase(base64, file)

      return {
        url,
        contentType: result,
      }
    } else {
      const base64 = await blobToBase64(file)
      return sendFileToFirebase(base64, file)
    }
  } catch (error) {
    console.error("Erro ao processar arquivo:", error)
    throw error
  }
}

const blobToDataUrl = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })

export const blobToBase64 = async (blob) => blobToDataUrl(blob)

export const getFileTypeFromUrl = async (url) => {
  try {
    const response = await fetch(url, { method: 'HEAD' });
    return response.ok ? response.headers.get('Content-Type') : null;
  } catch (error) {
    console.error(`Erro ao obter tipo de arquivo para ${url}:`, error);
    return null;
  }
}
